class Notifications {
  constructor(el) {
    this.el = el;
  }
  // function to create new elements with a class (cleans up code)
  createDiv(className = "") {
    const el = document.createElement("div");
    el.classList.add(className);
    return el;
  }
  // function to add text nodes to elements
  addText(el, text) {
    el.appendChild(document.createTextNode(text));
  }
  create(
    title = "Untitled notification",
    description = "",
    duration = 2,
    destroyOnClick = false,
    clickFunction = undefined
  ) {
    // functions
    function destroy(animate) {
      if (animate) {
        notiEl.classList.add("out");
        notiEl.addEventListener("animationend", () => {
          notiEl.remove();
        });
      } else {
        notiEl.remove();
      }
    }
    // create the elements and add their content
    const notiEl = this.createDiv("noti");
    const notiCardEl = this.createDiv("noticard");
    const glowEl = this.createDiv("notiglow");
    const borderEl = this.createDiv("notiborderglow");

    const titleEl = this.createDiv("notititle");
    this.addText(titleEl, title);

    const descriptionEl = this.createDiv("notidesc");
    this.addText(descriptionEl, description);

    // append the elements to each other
    notiEl.appendChild(notiCardEl);
    notiCardEl.appendChild(glowEl);
    notiCardEl.appendChild(borderEl);
    notiCardEl.appendChild(titleEl);
    notiCardEl.appendChild(descriptionEl);

    this.el.appendChild(notiEl);

    // transition the height of the container to the height of the visible card
    console.log("height", notiCardEl.scrollHeight);
    requestAnimationFrame(function () {
      notiEl.style.height =
        "calc(0.25rem + " + notiCardEl.getBoundingClientRect().height + "px)";
    });
    // hover animation
    notiEl.addEventListener("mousemove", (event) => {
      const rect = notiCardEl.getBoundingClientRect();
      const localX = (event.clientX - rect.left) / rect.width;
      const localY = (event.clientY - rect.top) / rect.height;

      console.log(localX, localY);
      glowEl.style.left = localX * 100 + "%";
      glowEl.style.top = localY * 100 + "%";

      borderEl.style.left = localX * 100 + "%";
      borderEl.style.top = localY * 100 + "%";
    });

    // onclick function if one is set
    if (clickFunction != undefined) {
      notiEl.addEventListener("click", clickFunction);
    }

    // destroy the notification on click if it is set to do so
    if (destroyOnClick) {
      notiEl.addEventListener("click", () => destroy(true));
    }

    // remove the notification after the set time if there is one
    if (duration != 0) {
      setTimeout(() => {
        notiEl.classList.add("out");
        notiEl.addEventListener("animationend", () => {
          notiEl.remove();
        });
      }, duration * 1000);
    }
    return notiEl;
  }
}

document.addEventListener('DOMContentLoaded', function() {
  // Configuration
  const MAX_PRIMARY_SELECTIONS = 3;
  const MAX_BONUS_SELECTIONS = 1;
  
  const notificationsContainer = document.querySelector(".notifications");
  const notis = notificationsContainer
    ? new Notifications(notificationsContainer)
    : null;

  // State management
  let primarySelections = new Map(); // Map of variant ID to quantity
  let bonusSelections = new Map(); // Map of variant ID to quantity
  let bonusUnlocked = false;
  
   // Helper: generate a unique bundle instance ID per "Add to cart"
  function createBundleInstanceId() {
    return `bundle-${Date.now().toString(36)}-${Math.random()
      .toString(36)
      .slice(2, 8)}`;
  }

  // DOM Elements
  const primaryCollection = document.querySelector('.primary-collection');
  const secondaryCollection = document.querySelector('.secondary-collection');
  const bonusLockedSection = document.getElementById('bonusLocked');
  const bonusUnlockedSection = document.getElementById('bonusUnlocked');
  const addToCartButtons = [document.getElementById('addToCartButton'), document.getElementById('addToCartButtonBTM')];
  const selectedItemsContainer = document.getElementById('selectedItemsContainer');
  const selectedBonusItemsContainer = document.getElementById('selectedBonusItemsContainer');
  
  // Initialize event listeners
  function init() {
    // Primary collection event listeners
    if (primaryCollection) {
      primaryCollection.querySelectorAll('.product-card').forEach(card => {
        const decreaseBtn = card.querySelector('.decrease');
        const increaseBtn = card.querySelector('.increase');

        decreaseBtn.addEventListener('click', (e) => handleQuantityChange(e, card, -1, 'primary'));
        increaseBtn.addEventListener('click', (e) => handleQuantityChange(e, card, 1, 'primary'));
      });
    }
    
    // Secondary collection event listeners (initially disabled)
    if (secondaryCollection) {
      secondaryCollection.querySelectorAll('.product-card').forEach(card => {
        const decreaseBtn = card.querySelector('.decrease');
        const increaseBtn = card.querySelector('.increase');
        
        decreaseBtn.addEventListener('click', (e) => handleQuantityChange(e, card, -1, 'secondary'));
        increaseBtn.addEventListener('click', (e) => handleQuantityChange(e, card, 1, 'secondary'));
      });
    }
    
    // Add to cart button event listeners
    addToCartButtons.forEach(button => {
      if (button) {
        button.addEventListener('click', handleAddToCart);
      }
    });
  }
  
  // Handle quantity changes
  function handleQuantityChange(event, card, change, collection) {
    event.preventDefault();
    
    const quantitySpan = card.querySelector('.quantity-count');
    const currentQty = parseInt(quantitySpan.textContent) || 0;
    const newQty = Math.max(0, currentQty + change);
    const variantId = card.dataset.variantId;
    const productTitle = card.querySelector('.product-title').textContent;
    
    // Check if we can add more
    if (collection === 'primary') {
      const currentTotal = getTotalSelections(primarySelections);
      if (change > 0 && currentTotal >= MAX_PRIMARY_SELECTIONS) {
        if (notis) notis.create('Limit Reached', 'Maximum 3 products allowed in primary selection.', 3, true);
        return;
      }
    } else if (collection === 'secondary') {
      if (!bonusUnlocked) {
        if (notis) notis.create('Locked', 'Complete primary selection first to unlock bonus items.', 3, true);
        return;
      }
      const currentTotal = getTotalSelections(bonusSelections);
      if (change > 0 && currentTotal >= MAX_BONUS_SELECTIONS) {
        if (notis) notis.create('Limit Reached', 'Maximum 1 bonus product allowed.', 3, true);
        return;
      }
    }
    
    // Update quantity
    quantitySpan.textContent = newQty;

    // Update selections
    if (collection === 'primary') {
      if (newQty === 0) {
        primarySelections.delete(variantId);
      } else {
        primarySelections.set(variantId, {
          quantity: newQty,
          title: productTitle,
          handle: card.dataset.productHandle,
          imageUrl: card.dataset.imageUrl
        });
      }
      updatePrimaryDisplay();
      checkUnlockBonus();
    } else {
      if (newQty === 0) {
        bonusSelections.delete(variantId);
      } else {
        bonusSelections.set(variantId, {
          quantity: newQty,
          title: productTitle,
          handle: card.dataset.productHandle,
          imageUrl: card.dataset.imageUrl
        });
      }
      updateBonusDisplay();
    }
    
    updateButtons();
  }
  
  // Get total selections count
  function getTotalSelections(selectionsMap) {
    let total = 0;
    selectionsMap.forEach(item => {
      total += item.quantity;
    });
    return total;
  }
  
  // Update primary selection display
  function updatePrimaryDisplay() {
    const items = [];
    primarySelections.forEach(item => {
      for (let i = 0; i < item.quantity; i++) {
        items.push({ title: item.title, imageUrl: item.imageUrl });
      }
    });

    // Update selected items display
    const emptySlots = MAX_PRIMARY_SELECTIONS - items.length;
    let html = '';

    items.forEach(item => {
      html += `<li class="filled-item"><img src="${item.imageUrl}" alt="${item.title}"><span>${item.title}</span></li>`;
    });

    for (let i = 0; i < emptySlots; i++) {
      html += '<li class="empty-item"></li>';
    }

    selectedItemsContainer.innerHTML = html;
  }
  
  // Update bonus selection display
  function updateBonusDisplay() {
    const items = [];
    bonusSelections.forEach(item => {
      for (let i = 0; i < item.quantity; i++) {
        items.push({ title: item.title, imageUrl: item.imageUrl });
      }
    });

    // Update selected bonus items display
    const emptySlots = MAX_BONUS_SELECTIONS - items.length;
    let html = '';

    items.forEach(item => {
      html += `<li class="filled-item filled"><img src="${item.imageUrl}" alt="${item.title}"><span>${item.title}</span></li>`;
    });

    for (let i = 0; i < emptySlots; i++) {
      html += '<li class="empty-bonus-item"></li>';
    }

    selectedBonusItemsContainer.innerHTML = html;
  }
  
  // Check if bonus collection should be unlocked
  function checkUnlockBonus() {
    const primaryTotal = getTotalSelections(primarySelections);
    
    if (primaryTotal === MAX_PRIMARY_SELECTIONS && !bonusUnlocked) {
      unlockBonusCollection();
    } else if (primaryTotal < MAX_PRIMARY_SELECTIONS && bonusUnlocked) {
      lockBonusCollection();
    }
  }
  
  // Unlock bonus collection
  function unlockBonusCollection() {
    bonusUnlocked = true;
    bonusLockedSection.style.display = 'none';
    bonusUnlockedSection.style.display = 'block';
    bonusUnlockedSection.classList.add('just-unlocked');
    
    // Enable bonus product buttons
    secondaryCollection.querySelectorAll('.quantity-selector button').forEach(btn => {
      btn.disabled = false;
    });
    
    // Scroll to bonus section
    setTimeout(() => {
      document.getElementById('bonustops').scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 300);

    if (notis) notis.create('Bonus Unlocked! 🎉', 'Choose 1 free bonus item.', 4, true);

    // Remove animation class after animation completes
    setTimeout(() => {
      bonusUnlockedSection.classList.remove('just-unlocked');
    }, 500);
  }
  
  // Lock bonus collection
  function lockBonusCollection() {
    bonusUnlocked = false;
    bonusLockedSection.style.display = 'block';
    bonusUnlockedSection.style.display = 'none';
    
    // Disable bonus product buttons and reset selections
    secondaryCollection.querySelectorAll('.product-card').forEach(card => {
      card.querySelector('.quantity-count').textContent = '0';
      card.querySelectorAll('.quantity-selector button').forEach(btn => {
        btn.disabled = true;
      });
    });
    
    // Clear bonus selections
    bonusSelections.clear();
    updateBonusDisplay();
    updateButtons();
  }
  
  // Update button states
  function updateButtons() {
    const primaryTotal = getTotalSelections(primarySelections);
    const bonusTotal = getTotalSelections(bonusSelections);
    
    addToCartButtons.forEach(button => {
      if (!button) return;
      
      const btnText = button.querySelector('#btntext') || button.querySelector('#btnBTMtext');
      
      if (primaryTotal === 0) {
        button.disabled = true;
        button.style.animation = 'none';
        if (btnText) btnText.textContent = 'CHOOSE 3 FLAVOURS TO CONTINUE';
      } else if (primaryTotal < MAX_PRIMARY_SELECTIONS) {
        button.disabled = true;
        button.style.animation = 'none';
        if (btnText) btnText.textContent = `SELECT ${MAX_PRIMARY_SELECTIONS - primaryTotal} MORE PRODUCTS`;
      } else if (primaryTotal === MAX_PRIMARY_SELECTIONS && bonusTotal === 0) {
        button.disabled = true;
        button.style.animation = 'none';
        if (btnText) btnText.textContent = 'NOW CHOOSE 1 FREE BONUS ITEM';
      } else if (bonusTotal < MAX_BONUS_SELECTIONS) {
        button.disabled = true;
        button.style.animation = 'none';
        if (btnText) btnText.textContent = 'SELECT YOUR FREE BONUS ITEM';
      } else if (primaryTotal === MAX_PRIMARY_SELECTIONS && bonusTotal === MAX_BONUS_SELECTIONS) {
        button.disabled = false;
        if (btnText) btnText.textContent = 'ADD ALL TO CART';
        button.style.animation = 'pulse 1s infinite';
      }
    });
  }
  
  // Handle add to cart
  async function handleAddToCart(event) {
    event.preventDefault();
    
    const button = event.currentTarget;
    const spinner = button.querySelector('.loading-overlay__spinner');
    const btnText = button.querySelector('#btntext') || button.querySelector('#btnBTMtext');
    
    // Show loading state
    if (spinner) spinner.classList.remove('hidden');
    if (btnText) btnText.textContent = 'ADDING TO CART...';
    button.disabled = true;
    
    try {
      // Prepare items for cart
      const items = [];
      const bundleKey = 'Mixed3-1';          // must match SIMPLE_BUNDLES["Mixed3-1"]
      const bundleInstanceId = createBundleInstanceId(); // unique per bundle instance

      // Add primary selections
      primarySelections.forEach((item, variantId) => {
        items.push({
          id: variantId,
          quantity: item.quantity,
          properties: {
            _bundleId: bundleInstanceId, // instance
            _bundleKey: bundleKey       // type key
          }
        });
      });
      
      // Add bonus selections (these will be transformed to free via cart transform)
      bonusSelections.forEach((item, variantId) => {
        items.push({
          id: variantId,
          quantity: item.quantity,
          properties: {
            _bundleId: bundleInstanceId, // instance
            _bundleKey: bundleKey       // type key
          }
        });
      });
      
      // Add all items to cart
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      });
      
      if (response.ok) {
        // Success - redirect to cart or show success message
        if (notis) notis.create('Success! ✅', 'Successfully added to cart!', 2, true);

        // Optional: Clear selections and reset
        setTimeout(() => {
          window.location.href = '/cart';
        }, 1000);
      } else {
        const errorData = await response.json();
        throw new Error(errorData.description || errorData.message || 'Failed to add items to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      if (notis) notis.create('Error ❌', error.message || 'Error adding to cart. Please try again.', 5, true);
    } finally {
      // Reset loading state
      if (spinner) spinner.classList.add('hidden');
      if (btnText) btnText.textContent = 'ADD ALL TO CART';
      button.disabled = false;
    }
  }
  
  // Initialize everything
  init();
});
